<template>
    <div
        class="c-cp-logo-rectangle"
        :style="rectangleStyle"
    >
        <img
            v-if="logo"
            class="c-cp-logo-rectangle__logo"
            :src="logo"
            :style="logoStyle"
            loading="lazy"
            decoding="async"
            @error="$emit('loadFailed')"
        >
    </div>
</template>

<script>
export default {
    name: 'CpLogoRectangle',
    emits: ['loadFailed'],
    props: {
        rectangleStyle: {
            type: String,
            default: '',
        },
        logoStyle: {
            type: String,
            default: '',
        },
        logo: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>

.c-cp-logo-rectangle {
    align-self: center;
    max-height: 100%;
    max-width: 100%;

    &__logo {
        height: auto;
        max-height: 40px;
        max-width: 180px;
        object-fit: contain;
        width: auto;
    }
}

@media (width <= 768px) {
    .c-cp-logo-rectangle {
        &__logo {
            max-width: 90px;
        }
    }
}
</style>
